import _                             from 'underscore';
import React, { FC }                 from 'react';
import { formatOption }              from '../../../../util';
import { SelectField }               from '../../../components/forms';
import { ACTIVITY_CRITICALITY }      from '../../../../constants/ProductEnums';
import { ACTIVITY_CRITICALITY_INFO } from '../../../../constants/ProductEnums';
import { PreSelectedSelectField }    from '../../../../types';
import { Label }                     from 'semantic-ui-react';
import { useProjectTermDictionary }  from '../../../../hooks/useTermDictionary';

interface Props extends PreSelectedSelectField {}

const Dropdown: FC<Props> = ( _props ) => {
	
	let { getTerm }         = useProjectTermDictionary(),
	    { facet, ...props } = _props;
	
	let options = _.values( ACTIVITY_CRITICALITY ).map( level =>
		formatOption( ACTIVITY_CRITICALITY[ level ], <><Label color={ ACTIVITY_CRITICALITY_INFO[ level ].COLOR } circular empty={ true }/>{ ' ' }{ getTerm( ACTIVITY_CRITICALITY_INFO[ level ].LABEL ) }</>, { key: ACTIVITY_CRITICALITY[ level ] } )
	);
	
	return (
		<SelectField
			{ ...props }
			options={ options }>
		</SelectField>
	);
};

export { Dropdown as ActivityCriticalityDropdown }
